import Image from "next/image";
import Link from "next/link";
import { FaDiscord, FaInstagram } from "react-icons/fa";

const navigation = {
  "Crayo Workflows": [
    { name: "Classic Split Screen", href: "https://crayo.ai/create/split-video?step=1" },
    { name: "Vertical Split Screen", href: "https://crayo.ai/create/vertical-split-video?step=1" },
    { name: "Reddit Story Video", href: "https://crayo.ai/create/reddit-video?step=1" },
    { name: "Fake Texts Video", href: "https://crayo.ai/create/text-video?step=1" },
    { name: "Streamer Video", href: "https://crayo.ai/create/streamer-video?step=1" },
  ],
  "AI Tools": [
    { name: "Voiceover Generator", href: "https://crayo.ai/tools/voiceovers" },
    { name: "Image Generator", href: "https://crayo.ai/tools/images" },
    { name: "Video Generator (VEO3)", href: "https://crayo.ai/tools/veo3" },
    { name: "Vocal Remover", href: "https://crayo.ai/tools/youtube-downloader" },
    { name: "Video & Image Background Remover", href: "https://crayo.ai/tools/remove-bg" },
  ],
  "Crayo Free Tools": [
    { name: "Audio Balancer", href: "https://crayo.ai/tools/free/audio-balancer" },
    { name: "Video Compressor", href: "https://crayo.ai/tools/free/video-compressor" },
    { name: "MP3 Converter", href: "https://crayo.ai/tools/free/mp3-converter" },
  ],
  product: [
    { name: "Pricing", href: "https://crayo.ai/pricing" },
    { name: "Enterprise", href: "mailto:support@crayo.ai" },
  ],
  legal: [
    { name: "Refund policy", href: "https://crayo.ai/refund-policy" },
    { name: "Terms of service", href: "https://crayo.ai/tos" },
    { name: "Privacy policy", href: "https://crayo.ai/privacy-policy" },
    { name: "Affiliate TOS", href: "https://crayo.ai/affiliate-tos" },
  ],
};

const socials = [
  {
    name: "X",
    href: "https://x.com/crayoai",
    icon: (
      <Image
        src="https://cdn-crayo.com/lp/public/footer-x.png"
        alt="X"
        width={0}
        height={0}
        className="size-5"
        style={{
          filter: "invert(1)",
          userSelect: "none",
          pointerEvents: "none",
          touchAction: "none",
        }}
      />
    ),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/crayoai",
    icon: <FaInstagram className="size-6 text-white" />,
  },
  {
    name: "Discord",
    href: "https://crayo.ai/discord",
    icon: <FaDiscord className="size-6 text-white" />,
  },
];

const Footer = () => {
  return (
    <div className="flex w-full flex-col items-center space-y-8 bg-[#2A66FF] p-6 sm:p-14">
      <footer className="mx-auto w-full max-w-screen-2xl rounded-3xl border border-[#E0E5EA] bg-white px-6 pb-14 shadow-sm lg:px-8">
        <div className="grid grid-cols-3 gap-8 py-12 pl-1">
          <div className="col-span-2 md:grid md:grid-cols-3 md:gap-8">
            <div>
              <h3 className="text-lg font-bold text-black">Workflows</h3>
              <ul role="list" className="mt-1.5 space-y-1.5">
                {navigation["Crayo Workflows"].map((item) => (
                  <li key={item.name}>
                    <a href={item.href} className="text-[13px] text-gray-700 hover:text-gray-900">
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="mt-10 md:mt-0">
              <h3 className="text-lg font-bold text-black">AI Tools</h3>
              <ul role="list" className="mt-1.5 space-y-1.5">
                {navigation["AI Tools"].map((item) => (
                  <li key={item.name}>
                    <a href={item.href} className="text-[13px] text-gray-700 hover:text-gray-900">
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="mt-10 md:mt-0">
              <h3 className="text-lg font-bold text-black">Free Tools</h3>
              <ul role="list" className="mt-1.5 space-y-1.5">
                {navigation["Crayo Free Tools"].map((item) => (
                  <li key={item.name}>
                    <a href={item.href} className="text-[13px] text-gray-700 hover:text-gray-900">
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="md:grid md:grid-cols-2 md:gap-8">
            <div>
              <h3 className="text-lg font-bold text-black">Product</h3>
              <ul role="list" className="mt-1.5 space-y-1.5">
                {navigation.product.map((item) => (
                  <li key={item.name}>
                    <a href={item.href} className="text-[13px] text-gray-700 hover:text-gray-900">
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="mt-10 md:mt-0">
              <h3 className="text-lg font-bold text-black">Legal</h3>
              <ul role="list" className="mt-1.5 space-y-1.5">
                {navigation.legal.map((item) => (
                  <li key={item.name}>
                    <a href={item.href} className="text-[13px] text-gray-700 hover:text-gray-900">
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between pt-8">
          <Link
            href="/"
            className="w-1/4"
            onClick={(e) => {
              if (window.location.pathname === "/") {
                e.preventDefault();
                document.getElementById("top")?.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            <Image
              src="https://cdn-crayo.com/lp/public/crayoBlue.png"
              alt="Crayo Logo"
              width={126}
              height={28.5}
              draggable={false}
              style={{
                userSelect: "none",
                pointerEvents: "none",
                touchAction: "none",
              }}
            />
          </Link>
          <div className="flex items-center space-x-2.5">
            {socials.map((social) => (
              <button key={social.name}>
                <Link
                  {...(social.href === "https://crayo.ai/discord" && { prefetch: false })}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="flex size-11 items-center justify-center rounded-full bg-[#2A66FF] p-2.5">
                    {social.icon}
                  </div>
                </Link>
              </button>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
